import { Component, ViewEncapsulation } from "@angular/core";
import { NotificationsAppService } from "../shared/services/notifications-app.service";
import { Router } from "@angular/router";
import { AuthRefreshService } from "../shared/services/auth-refresh.service";
import { AuthenticationService } from "../services/authentication.service";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"]
})
export class PagesComponent {
  constructor(private notyApp: NotificationsAppService, public router: Router, public authRefresh: AuthRefreshService,
    public authServ: AuthenticationService) {
  }
  unsubscribe$: Subject<void> = new Subject();
  timerSubscription: Subscription;

  ngOnInit() {
    this.authRefresh.timerActionOccured.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(() => {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts